var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPaxError = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99805 47.998C7.99805 25.878 25.878 7.99805 47.998 7.99805C70.118 7.99805 87.998 25.878 87.998 47.998C87.998 70.118 70.118 87.998 47.998 87.998C25.878 87.998 7.99805 70.118 7.99805 47.998ZM59.5609 65.2009C61.1209 66.7609 63.6409 66.7609 65.2009 65.2009C66.7209 63.6409 66.7209 61.0809 65.2009 59.5609L53.6409 48.0009L65.2009 36.4409C66.7609 34.8809 66.7609 32.3609 65.2009 30.8009C63.6409 29.2409 61.1209 29.2409 59.5609 30.8009L48.0009 42.3609L36.4409 30.8009C34.8809 29.2409 32.3609 29.2409 30.8009 30.8009C29.2409 32.3609 29.2409 34.8809 30.8009 36.4409L42.3609 48.0009L30.8009 59.5609C29.2409 61.1209 29.2409 63.6409 30.8009 65.2009C32.3609 66.7609 34.8809 66.7609 36.4409 65.2009L48.0009 53.6409L59.5609 65.2009Z",
    fill: "#383838"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPaxError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pax-error.999b363dbdb9dcfb52c7cefc6b3b2e55.svg";